import React from 'react';
import './Navbar.css';

function Navbar({ activeTab, setActiveTab }) {
  const navItems = [
    { key: 'biology', label: 'Biology & Physiology' },
    { key: 'kittens', label: 'Kitten Development' },
    { key: 'care', label: 'Ethical Care & Health' },
    { key: 'respect', label: 'Decoding Respect' },
    { key: 'quiz', label: 'Ethology Quiz' }
  ];

  return (
    <nav className="top-navbar">
      <div className="nav-inner">
        <div className="brand">
          <span className="brand-icon">🐾</span>
          <span className="brand-title">FELIDAE BIOLOGY</span>
        </div>
        <div className="nav-links">
          {navItems.map((item) => (
            <button
              key={item.key}
              className={`nav-button ${activeTab === item.key ? 'active' : ''}`}
              onClick={() => setActiveTab(item.key)}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;